import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const oneYearsOldDrawing: BlogMetaData = {
  title: '1歳 お絵かき モンテッソーリ｜始め方・道具・声かけ（家で3分）',
  description:
    '1歳のお絵かきをモンテッソーリで始める方法。環境づくり／道具の選び方／声かけ・関わり方を年齢に合わせて丁寧に解説。家庭で今すぐできる実践手順つき。',
  thumbnailUrl: '/img/blog-1-year-old-drawing.webp',
  filePath: buildBlogFilePath('1-years-old-drawing'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
